import { render } from "./schools-breadcrumb.vue?vue&type=template&id=29dea7ec"
import script from "./schools-breadcrumb.js?vue&type=script&lang=js"
export * from "./schools-breadcrumb.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__